import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  DownloadOutlined,
  SyncOutlined,
  DeleteOutlined,
  CreditCardOutlined,
  LoadingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined
} from "@ant-design/icons";
import FilterComponent from "views/components/Layouts/Filter";
import {
  Tabs,
  Table,
  Button,
  Modal,
  Form,
  DatePicker,
  Checkbox,
  Input,
  Switch,
  Tooltip,
  Spin,
  Collapse,
  Row,
  Col,
  Select,
  Tag,
  Progress,
} from "antd";
import type { FormProps, TablePaginationConfig } from "antd";
import { message } from "antd";
import { useSelector } from "react-redux";
import {
  createLogMetadata,
  deleteLogId,
  deleteLogManagement,
  editDisplayLogManagement,
  editLogManagement,
  exportDataLogName,
  fetchLogMonitoring,
  fetchLogMonitoringFilter,
  fetchSecurityMonitoring,
  getDataSecurityMonitoring,
  getDataUploadLog,
  getLastUpdate,
  getLogSecurityMonitoring,
  getProcessJob,
  latestUpdateMetadata,
  reloadDataManagement,
  uploadFileLog,
} from "features/security-monitoring/store/slice";
import { useDispatch } from "react-redux";
import { ReactComponent as Edit } from "assets/img/Edit.svg";
import { ReactComponent as Delete } from "assets/img/Delete.svg";
import styles from "./styles.module.scss";
import {
  IFilter,
  ILogManagementBase,
  IRowLogManagement
} from "../interface";
import {
  ISecurityLogBase,
  ISecurityMonitoringData,
} from "types/models/security-monitoring";
import {
  APP_LOCAL_DATE_FORMAT,
  APP_LOCAL_DATE_FORMAT_LOWER_CASE,
  APP_LOCAL_DATETIME_FORMAT_NOTIFY,
  SUPER_ADMIN_ROLE,
} from "utils/constants";
import useNotify from "apps/hooks/useNotify";
import TabPane from "antd/es/tabs/TabPane";
import { getUserInfo } from "features/auth/store/slice";
import { formatDateIfNull } from "utils";
import {
  FilterValue,
  SorterResult,
  TableCurrentDataSource,
} from "antd/es/table/interface";
import CheckboxFilter from "views/components/select-filter";
import { ModalCancel } from "views/components/Layouts/ModalCancel";

const LOCATION_DATA = [
  {
    label: "KIC",
    value: "KIC"
  }, {
    label: "AIC",
    value: "AIC"
  }, {
    label: "EIC",
    value: "EIC"
  }, {
    label: "RUC",
    value: "RUC"
  }
]

const { Panel } = Collapse;

const { RangePicker } = DatePicker;

const { confirm } = Modal;

export const renderContentFilterSecurityMonitoring = () => {
  return (
    <Form.Item name="time" label="Log Updated Time">
      <RangePicker
        placeholder={[
          APP_LOCAL_DATE_FORMAT_LOWER_CASE,
          APP_LOCAL_DATE_FORMAT_LOWER_CASE,
        ]}
        format={APP_LOCAL_DATE_FORMAT}
      />
    </Form.Item>
  );
};

interface tabLogNameProps {
  tabLogName: (data: string[]) => void;
}

const TabLog: React.FC<tabLogNameProps> = ({ tabLogName }) => {
  const dispatch = useDispatch();
  // Selector reducer
  const user_info = useSelector(getUserInfo);
  const metaData = useSelector(getDataSecurityMonitoring);
  const logData = useSelector(getLogSecurityMonitoring);
  // tabLogName()
  const uploadLog = useSelector(getDataUploadLog);
  const lastUpdate = useSelector(getLastUpdate);
  // End selector reducer
  const jobProcess = useSelector(getProcessJob);

  const tabDefault = Object.keys(logData)[0];

  const [loadings, setLoadings] = useState<boolean>(true);
  const [openLogManagement, setOpenLogManagement] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const [openCreateNewLog, setOpenCreateNewLog] = useState(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [formFilter] = Form.useForm();
  const [formUploadCreate] = Form.useForm();
  const [rows, setRows] = useState<IRowLogManagement[]>([]);
  const [selectedRows, setSelectedRows] = useState<IFilter[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [selectedTabs, setSelectedTabs] = useState<string[]>(() => {
  return logData && Object.keys(logData).length > 0 ? [Object.keys(logData)[0]] : [];
});

  const [isShowModalProgress, setIsShowModalProgress] = useState(false);

  const [filter, setFilter] = useState<Boolean>(false);
  const [resultUpload, setResultUpload] = useState<ILogManagementBase[]>([]);
  const notify = useNotify();

  const [createUploadModal, setIsCreateUploadModal] = useState(false);
  const [filterData, setFilteredData] = useState<IFilter[]>([]);

  const tabNames = Object.keys(logData || {}); // Lấy ra danh sách các tabName
  const [selectedTabName, setSelectedTabName] = useState<string | undefined>(
    undefined
  ); // State để lưu tabName

  //=========== Table Log Main ===========
  const columnLogManagement = [
    {
      title: "Selection",
      dataIndex: "disable",
      key: "disable",
      render: (_: any, record: any, index: any) => (
        <Checkbox
          key={index}
          checked={record.disable === undefined ? false : !record.disable}
          onChange={(e) => handleSelectDisplayLogM(e, index, record)}
        />
      ),
    },
    {
      title: "Log Name",
      dataIndex: "log_name",
      key: "log_name",
    },
    {
      title: "Status",
      dataIndex: "state",
      key: "state",
      render: (_:any, record: any, index: any) => {
        switch (record.state) {
          case 'success':
            return <Tag icon={<CheckCircleOutlined />} color="success">
              {record.state}
            </Tag>
          case 'in-progress':
            return <Tag icon={<SyncOutlined spin />} color="processing">
              {record.state}
            </Tag>
          case 'failed':
            return <Tag icon={<CloseCircleOutlined />} color="processing">
              {record.state}
            </Tag>
          default:
            break;
        }
      }
    },
    {
      title: <div style={{ textAlign: "center" }}>Action</div>,
      key: "action",
      render: (_: any, record: ISecurityMonitoringData) => (
        <div className={styles.action_form}>
          <div>
            <Button
              type="text"
              size="small"
              icon={<Edit />}
              onClick={() => showEditModal(record)}
            />
          </div>
          <div>
            <Button
              type="text"
              size="small"
              icon={<Delete />}
              onClick={() => showDeleteConfirm(record.log_name)}
            />
          </div>
        </div>
      ),
    },
  ];

  const handleSelectDisplayLogM = (e: any, index: number, record: any) => {
    const isChecked = e.target.checked; // Lấy trạng thái checked
    const updatedRecord = {
      ...metaData[index],
      disable: !isChecked, // Đảo ngược trạng thái `disable`
    };
    const log_name = updatedRecord.log_name;
    const disable = updatedRecord.disable;
    dispatch(
      editDisplayLogManagement({
        log_name,
        disable,
      })
    );
  };

  const showDeleteConfirm = (logName: string) => {
    confirm({
      title: "Are you sure you want to delete this?",
      content: "This action cannot be undone.",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        dispatch(deleteLogManagement(logName));
      },
      onCancel() {},
    });
  };
  //=========== End table Log Main ===========

  //=========== Modal Log Edit ===========
  const rowEditLogManagement = [
    {
      title: "Column Name",
      key: "modified",
      dataIndex: "modified",
      render: (_: any, record: any, index: any) => (
        <Input
          value={record.modified}
          onChange={(e) => handleChangeModified(e.target.value, index)}
        />
      ),
    },
    {
      title: "Column from SCV/Excel file",
      key: "origin",
      dataIndex: "origin",
      render: (_: any, record: any, index: number) => (
        <Input value={record.origin} disabled />
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>Display</div>,
      key: "action",
      render: (_: any, record: any, index: number) => (
        <div style={{ textAlign: "center" }}>
          <Switch
            checked={!record.disable}
            onChange={(e) => handleChangeDisable(e, index)}
          />
        </div>
      ),
    },
  ];

  const handleChangeModified = (value: string, index: number) => {
    const newRow = [...rows] as IRowLogManagement[];
    newRow[index].modified = value;
    setRows([...newRow]);
  };

  const handleChangeDisable = (value: boolean, index: number) => {
    const newRow = [...rows] as IRowLogManagement[];
    newRow[index].disable = !value;
    setRows([...newRow]);
  };

  const handleSubmitEdit: FormProps<ILogManagementBase[]>["onFinish"] = async (
    values
  ) => {
    const logName = values;
    const payload = [...rows];
    dispatch(
      editLogManagement({
        logName,
        payload,
      })
    );
  };
  //=========== End Log Edit ===========

  const selectedFiltersRef = useRef<Record<string, any>>({});

  // ============ Dynamic table ===========
  // Hàm tạo columns và dataSource từ từng phần dữ liệu
  const createColumnsAndDataSource = (logData: any) => {
    if (!logData || logData.length === 0) {
      return { columns: [], dataSource: [] };
    }
    const columns = Object.keys(logData[0])
      .filter((key) => key !== "id")
      .map((key) => {
        const values = logData.map((item: any) => item[key]);
        const isDatetime = values.some((value: any) => {
          if (typeof value !== "string" || /^\d+$/.test(value)){
            return false;
          }
          const validDateFormats = [
            /^\d{4}-\d{2}-\d{2}$/,       // YYYY-MM-DD
            /^\d{4}\/\d{2}\/\d{2}$/,     // YYYY/MM/DD
            /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/, // YYYY-MM-DD HH:mm:ss
            /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/, // YYYY/MM/DD HH:mm:ss
            /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{3}$/, // YYYY-MM-DD HH:mm:ss.SSS
            /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}\.\d{3}$/,
          ];

          return validDateFormats.some((regex) => regex.test(value));
        });
        const filters = [...new Set(values)].map((value) => ({
          text: String(value),
          value: value as string | number | boolean,
          type: isDatetime,
        }));

        return {
          title: key,
          dataIndex: key,
          key: key,
          width: 150,
          ellipsis: {
            showTitle: true,
          },
          render: (text: any) => (
            <Tooltip title={text}>
              <span className={styles.ellipsis}>{text}</span>
            </Tooltip>
          ),
          filterDropdown: ({ setSelectedKeys, confirm }: any) => (
            <CheckboxFilter
              filters={filters}
              columnName={key}
              type={isDatetime ? "datetime" : "text"}
              onApplyFilter={(selectedValues) => {
                setSelectedKeys(selectedValues);
                selectedFiltersRef.current[key] = selectedValues;
                confirm();
              }}
              onReset={() => {
                setSelectedKeys([]);
                delete selectedFiltersRef.current[key];
              }}
            />
          ),
          onFilter: (_value: any, record: any) => {
            const selected = selectedFiltersRef.current[key];
          
            if (isDatetime && Array.isArray(selected) && selected.length === 2) {
              const recordDate = new Date(record[key]).getTime();
              const startDate = new Date(selected[0]).getTime();
              const endDate = new Date(selected[1]).getTime();
              return recordDate >= startDate && recordDate <= endDate;
            }
          
            if (Array.isArray(selected)) {
              return selected.includes(record[key]);
            }
          
            return true;
          },
          sorter: (a: any, b: any) => {
            if (isDatetime) {
              return new Date(a[key]).getTime() - new Date(b[key]).getTime();
            }
            if (typeof a[key] === "number" && typeof b[key] === "number") {
              return a[key] - b[key];
            }
            if (typeof a[key] === "string" && typeof b[key] === "string") {
              return a[key].localeCompare(b[key]);
            }
            return 0;
          },
          filterSearch: true,
        };
      });

    // Thêm key vào dataSource nếu chưa có
    const dataSource = logData.map((item: any, index: any) => ({
      ...item,
      key: index, // Thêm key dựa trên index
    }));

    return { columns, dataSource };
  };
  // Tạo các tab dựa trên dữ liệu dynamic

  const tabs = Object.keys(logData || {}).map((tabName, index) => {
    const data = logData[tabName as keyof ISecurityLogBase];
    const { columns, dataSource } = createColumnsAndDataSource(data);
    return {
      key: tabName,
      tab: (
        <div style={{ fontSize: "17px" }}>
          <Checkbox
            defaultChecked={index === 0} // Chọn mặc định phần tử đầu tiên
            onChange={(e) => handleCheckboxChange(tabName, e.target.checked)} // Handle checkbox changes
          />
          <span style={{ marginLeft: "5px" }}>{tabName}</span>
        </div>
      ),
      columns,
      dataSource,
    };
  });

  const handleCheckboxChange = (tab: string, isChecked: boolean) => {
    let updatedTabs: string[];
    if (isChecked) {
      const tmp = tabDefault;
      updatedTabs = [...selectedTabs, tab];
    } else {
      // Remove tab from the selected list if unchecked
      updatedTabs = selectedTabs.filter((t) => t !== tab);
    }

    setSelectedTabs(updatedTabs); // Update local state
    tabLogName(updatedTabs); // Send updated list to parent
  };

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      setSelectedRows(selectedRows); // Cập nhật state các hàng đã chọn
    },
  };

  const handleChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<IFilter> | SorterResult<IFilter>[],
    extra: TableCurrentDataSource<IFilter>
  ) => {
    if (extra.action === "filter" || extra.action === "sort") {
      setFilter(true);
      setFilteredData(extra.currentDataSource); // Dữ liệu sau khi filter/sort
    }
  };

  const handleSelectAll = (dataSources: any[]) => {
    // Tìm tab hiện tại dựa trên key (selectedTabName)
    const findTab = dataSources.find((item) => item.key === selectedTabName);

    if (findTab) {
      if (filterData && filterData.length > 0) {
        // Nếu có filter, chọn tất cả các dòng đã lọc
        if (filter) {
          setSelectedRows(filterData);
        } else {
          setSelectedRows([]);
        }
        setFilter(!filter);
        setSelectAll(!selectAll);
      } else {
        // Nếu không có filter, chọn tất cả hoặc bỏ chọn tất cả
        if (selectAll) {
          setSelectedRows([]); // Bỏ chọn tất cả
        } else {
          setSelectedRows(findTab.dataSource); // Chọn tất cả
        }
      }

      // Đổi trạng thái selectAll
      setSelectAll(!selectAll);
    } else {
      // Xử lý trường hợp không tìm thấy tab
      message.info("Error: Tab not found!");
    }
  };

  //=========== End dynamic table ===========

  //=========== Show modal edit  ===========
  const showEditModal = (record: any) => {
    if (!record.column_name) {
      message.info("No data");
      return;
    }
    form.setFieldValue("log_name", record.log_name);
    // Tạo dataSource từ mảng `column_name`
    const dataSource = record.column_name.map((item: any, index: any) => ({
      key: index, // Thêm key duy nhất
      ...item, // Truyền các giá trị của đối tượng gốc
    }));
    setIsEditModal(true);
    setRows(dataSource);
  };
  // =========== End show modal edit  ===========

  // show modal create
  const showCreateLogModal = () => {
    setOpenCreateNewLog(true);
  };

  // show modal delete
  const showDeleteModal = () => {
    setDeleteModal(true);
  };

  const enterLoading = () => {
    setLoadings(true);
    try {
      dispatch(reloadDataManagement());
    } catch (error) {
      message.error("Error");
    } finally {
      setLoadings(false);
    }
  };

  // Filter
  const handleRefetch = () => {
    const createDate = formFilter.getFieldValue("time");
    if (createDate !== undefined) {
      dispatch(
        fetchLogMonitoringFilter({
          start_date: formatDateIfNull(
            createDate?.[0],
            APP_LOCAL_DATETIME_FORMAT_NOTIFY
          ),
          end_date: formatDateIfNull(
            createDate?.[1],
            APP_LOCAL_DATETIME_FORMAT_NOTIFY
          ),
        })
      );
    } else {
      notify("Start date and end date cannot be blank", "error");
    }
  };

  const handleReset = () => {
    formFilter.resetFields();
    dispatch(fetchLogMonitoring());
  };

  //=========== Export File ===========
  const handleExportClick = () => {
    if (!selectedRows || selectedRows.length === 0 || !selectedTabName) {
      message.warning("Export failed: No data selected or no tab selected.");
      return;
    }

    const sizeInBytes = new TextEncoder().encode(
      JSON.stringify(selectedRows)
    ).length;

    const MB = 1048576;
    const KB = 1024;

    let displaySize;
    let sizeExceeded = false;

    if (sizeInBytes > MB) {
      const resultMB = sizeInBytes / MB;
      displaySize = `${resultMB.toFixed(2)} MB`;
      if (resultMB > 100) {
        sizeExceeded = true;
      }
    } else {
      const resultKB = sizeInBytes / KB;
      displaySize = `${resultKB.toFixed(2)} KB`;
      if (resultKB > 102400) {
        sizeExceeded = true;
      }
    }

    if (sizeExceeded) {
      message.error("File size exceeds 100MB. Export not allowed.");
      return;
    }

    Modal.confirm({
      title: "Confirm Export",
      content: `The file size is approximately ${displaySize}. Do you want to proceed?`,
      onOk() {
        dispatch(
          exportDataLogName({
            name: selectedTabName,
            log_ids: selectedRows.map((record) => record.id),
          })
        );
        setSelectedRows([]);
      },
      onCancel() {
        message.info("Export canceled.");
      },
    });
  };
  //=========== End Export file ===========

  //=========== DELETE ID OR MORE ===========
  const handleDeleteLogById = () => {
    const logName = selectedTabName;
    const listLogId = selectedRows;
    if (!listLogId || listLogId.length === 0 || !logName) {
      message.warning("Delete failed: No data selected or no tab selected.");
      return;
    }
    dispatch(
      deleteLogId({
        log_name: logName,
        log_ids: listLogId.map((record) => record.id),
      })
    );
    setSelectedRows([]);
    fetchLogMonitoring();
    setDeleteModal(false);
  };
  //=========== END DELETE ID OR MORE ===========

  //=========== Upload File ===========
  const handleOnChangeUploadFile = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) {
      message.warning("No file selected.");
      return;
    }
    setFile(files[0]);
  };
  const handleSubmitUploadFile = (values: any) => {
    if (!file) {
      message.error("Please select a file before uploading.");
      return;
    }

    const logName = values.name;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("location", values.location);
    formData.append("log_name", logName);

    if (!values.location) {
      message.warning("Please choose location!");
      return;
    }
    if (!logName) {
      message.warning("Please enter log name!");
      return;
    }
    if (metaData.some(item => item.log_name === logName)) {
      message.warning("Log name already exists.");
      return;
    }

    dispatch(
      uploadFileLog({
        log_name: logName,
        formData,
        filename: file.name
      })
    );

    form.resetFields();
    setOpenCreateNewLog(false);
    setFile(null);
    setIsCreateUploadModal(true);
    formUploadCreate.setFieldValue("log_name", logName);
  };

  useEffect(() => {
    if (uploadLog != null && uploadLog) {
      const resultCreate = createColumns(uploadLog.column_name);
      setResultUpload(resultCreate);
    }
  }, [uploadLog]);
  //=========== End Upload File ===========

  const rowCreateLogManagement = [
    {
      title: "Column Name",
      key: "modified",
      dataIndex: "modified",
      render: (_: any, record: any, index: any) => (
        <Input
          value={record.modified}
          onChange={(e) => handleChangeCreateModified(e.target.value, index)}
        />
      ),
    },
    {
      title: "Column from SCV/Excel file",
      key: "origin",
      dataIndex: "origin",
      render: (_: any, record: any, index: number) => (
        <Input value={record.origin} disabled />
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>Display</div>,
      key: "action",
      render: (_: any, record: any, index: number) => (
        <div style={{ textAlign: "center" }}>
          <Switch
            checked={!record.disable}
            onChange={(e) => handleChangeCreateDisable(e, index)}
          />
        </div>
      ),
    },
  ];

  const handleChangeCreateModified = (value: string, index: number) => {
    const newRow = [...resultUpload] as IRowLogManagement[];
    newRow[index].modified = value;
    setResultUpload([...newRow]);
  };

  const handleChangeCreateDisable = (value: boolean, index: number) => {
    const newRow = [...resultUpload] as IRowLogManagement[];
    newRow[index].disable = !value;
    setResultUpload([...newRow]);
  };

  // Hàm chuyển đổi map data từ upload và column_name metadata
  function createColumns(data: any) {
    return data?.map((item: any) => ({
      origin: item,
      modified: item,
      disable: false,
    }));
  }

  const handleCreateUpload = () => {
    const log_name = formUploadCreate.getFieldValue("log_name");
    dispatch(
      createLogMetadata({
        log_name: log_name,
        column_name: resultUpload,
      })
    );
    setIsCreateUploadModal(false);
    setOpenCreateNewLog(false);
    formUploadCreate.resetFields();
  };

  function formatDateTimeWithAmPm(dateString: string) {
    const date = new Date(dateString); // Chuyển chuỗi thành đối tượng Date

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Thêm 0 nếu cần
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours(); // Lấy giờ
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const amPm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${amPm}`;
  }

  useEffect(() => {
    if(jobProcess){
      setIsShowModalProgress(true);
    } else {
      setIsShowModalProgress(false);
    }
  }, [jobProcess])

  useEffect(() => {
    const loadDataLog = () => {
      setLoadings(true);
      try {
        dispatch(fetchSecurityMonitoring());
        dispatch(fetchLogMonitoring());
        dispatch(latestUpdateMetadata());
        setTimeout(() => {
          setLoadings(false);
        }, 6500);
      } catch (error) {
        setLoadings(false);
      }
    };
    // featchAuthen();

    loadDataLog();
  }, [dispatch]);

  useEffect(() => {
    if (tabNames.length > 0 && !selectedTabName) {
      setSelectedTabName(tabNames[0]);
      tabLogName([tabDefault]);
      setSelectedTabs([tabDefault])
    }
  }, [tabNames, selectedTabName, selectedTabs]);

  return (
    <>
      <Collapse defaultActiveKey={['1']}>
        <Panel header={
            <div className={styles.page_header}>
              <div className={styles.content_header}>Violation Viewer</div>
              <div className={styles.real_time}>
                Last update: {formatDateTimeWithAmPm(lastUpdate.data)}
              </div>
            </div>
        } key="1">
          <div className={styles.content_document}>
            <div className={styles.form_btn}>
              <div>
                <Button
                  onClick={() => handleSelectAll(tabs)}
                  className={styles.btn_select}
                >
                  {selectAll
                    ? `Deselect All: ${selectedRows.length}`
                    : `Select All: ${selectedRows.length}`}
                </Button>
              </div>
              <div className={styles.form_flex_btn}>
                {user_info?.role === SUPER_ADMIN_ROLE && (
                  <Button
                    icon={<DeleteOutlined />}
                    onClick={showDeleteModal}
                    className={styles.delete}
                  >
                    Delete
                  </Button>
                )}
                <FilterComponent
                  contentFilter={renderContentFilterSecurityMonitoring()}
                  onOk={() => {
                    handleRefetch();
                  }}
                  resetFunc={() => {
                    handleReset();
                  }}
                  form={formFilter}
                />
                <Button
                  type="primary"
                  icon={<SyncOutlined />}
                  loading={loadings}
                  onClick={() => enterLoading()}
                  className={styles.btn}
                >
                  Refresh
                </Button>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  className={styles.btn}
                  onClick={handleExportClick}
                >
                  Export
                </Button>
                {user_info?.role === SUPER_ADMIN_ROLE && (
                  <Button
                    type="primary"
                    className={styles.btn_default}
                    onClick={() => setOpenLogManagement(true)}
                  >
                    Log Management
                  </Button>
                )}
              </div>
            </div>
            {loadings ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                }}
              >
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
                />
              </div>
            ) : (
              <div>
                <Tabs
                  activeKey={selectedTabName} // Đặt tab hiện tại dựa vào state
                  onChange={(activeKey) => {
                    setSelectedTabName(activeKey);
                    setSelectedRows([]); // Reset selectedRows khi chuyển tab
                    setSelectAll(false);
                  }} // Cập nhật state khi chuyển tab
                >
                  {tabs.map((tab) => (
                    <TabPane tab={tab.tab} key={tab.key}>
                      <Table
                        columns={tab.columns}
                        dataSource={tab.dataSource}
                        // pagination={false}
                        rowSelection={{
                          ...rowSelection, // Giữ nguyên logic chọn hàng
                          selectedRowKeys: selectedRows.map((row: any) => row.key), // Tự động cập nhật rowKeys
                        }}
                        scroll={{
                          x: 1000,
                          y: 350,
                        }}
                        onChange={handleChange}
                      />
                    </TabPane>
                  ))}
                </Tabs>
              </div>
            )}
          </div>
        </Panel>
      </Collapse>

      {/* View Log management */}
      <Modal
        title="Log Management"
        centered
        open={openLogManagement}
        onOk={() => setOpenLogManagement(false)}
        onCancel={() => setOpenLogManagement(false)}
        width={700}
        footer={null}
        className={styles.modal_log}
      >
        <div>
          <div
            style={{
              fontSize: "20px",
              textAlign: "end",
              color: "#57AEFF",
            }}
          >
            <CreditCardOutlined onClick={() => showCreateLogModal()} size={30} />
          </div>

          <Table
            columns={columnLogManagement}
            dataSource={metaData}
            pagination={false}
            scroll={{y: 250}}
          />
        </div>
      </Modal>

      {/* Delete  */}
      <Modal
        centered
        open={deleteModal}
        onOk={() => handleDeleteLogById()}
        onCancel={() => setDeleteModal(false)}
      >
        <div className={styles.confirm_delete}>
          <div className={styles.confirm_delete_title}>Confirm Delete</div>
          <div className={styles.confirm_delete_description}>
            <p>Are you sure you want to delete the selected records?</p>
            <p>This action cannot be undone.</p>
          </div>
        </div>
      </Modal>

      {/* Create  */}
      <Modal
        title="Create New Log"
        centered
        width={550}
        footer={null}
        onOk={() => setOpenCreateNewLog(false)}
        onCancel={() => {
          form.resetFields();
          setOpenCreateNewLog(false);
        }}
        open={openCreateNewLog}
      >
        <Form form={form} onFinish={handleSubmitUploadFile} layout="horizontal">
          <Row className={styles.text_input}>
            <Col span={8}>
              <div className={styles.label}>
                Location
              </div>
            </Col>
            <Col span={16}>
              <Form.Item name="location">
                <Select
                  className={styles.input_ant}
                  options={LOCATION_DATA}
                  placeholder="Choose"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className={styles.text_input}>
            <Col span={8}>
              <div className={styles.label}>
                Name
              </div>
            </Col>
            <Col span={16}>
              <Form.Item name="name">
                <Input placeholder="Please input New Log Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row className={styles.text_input}>
            <Col span={8}>
              <div className={styles.label}>
                File
              </div>
            </Col>
            <Col span={16}>
              <Form.Item
                style={{ width: "500px"}}
                name="file"
              >
                <input type="file" onChange={handleOnChangeUploadFile} />
              </Form.Item>
            </Col>
          </Row>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "3px" }}>
            <Button type="text" onClick={() => setOpenCreateNewLog(false)}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Upload
            </Button>
          </div>
        </Form>
      </Modal>

      <ModalCancel
        content={
          <div style={{ width: "100%" }}>
            <Progress
              type="circle"
              percent={Number(jobProcess)}
              strokeColor={{
                "0%": "#87d068",
                "50%": "#ffe58f",
                "100%": "#ffccc7",
              }}
            />
          </div>
        }
        subContent={"The process is running!"}
        modalIcon={<></>}
        open={isShowModalProgress}
        isClose={false}
      />

      {/* Edit logType  */}
      <Modal
        title="Log Management"
        centered
        width={700}
        footer={null}
        onOk={() => setIsEditModal(false)}
        onCancel={() => setIsEditModal(false)}
        open={isEditModal}
      >
        <Form form={form} layout="horizontal" onFinish={handleSubmitEdit}>
          <Form.Item label="Name" name="log_name">
            <Input disabled />
          </Form.Item>
          <Table
            columns={rowEditLogManagement}
            dataSource={rows}
            pagination={false}
            scroll={{
              y: 440, // Chiều cao tối đa của bảng, nếu vượt quá sẽ bật scroll
            }}
            rowKey={(record, index: any) => index.toString()} // Sử dụng index làm key
          />
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              gap: "3px",
              marginTop: "5px",
            }}
          >
            <Button type="text" onClick={() => setIsEditModal(false)}>
              Cancle
            </Button>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </div>
        </Form>
      </Modal>

      {/* Create Upload  */}
      <Modal
        title="Log Management"
        centered
        width={700}
        footer={null}
        onOk={() => setIsCreateUploadModal(false)}
        onCancel={() => setIsCreateUploadModal(false)}
        open={createUploadModal}
      >
        <Form
          form={formUploadCreate}
          layout="horizontal"
          onFinish={handleCreateUpload}
        >
          <Form.Item label="Name" name="log_name">
            <Input disabled />
          </Form.Item>
          <Table
            columns={rowCreateLogManagement}
            dataSource={resultUpload}
            pagination={false}
            scroll={{
              y: 440, // Chiều cao tối đa của bảng, nếu vượt quá sẽ bật scroll
            }}
            rowKey={(record, index: any) => index.toString()} // Sử dụng index làm key
          />
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              gap: "3px",
              marginTop: "5px",
            }}
          >
            <Button type="text" onClick={() => setIsCreateUploadModal(false)}>
              Cancle
            </Button>
            <Button type="primary" htmlType="submit">
              Create
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default TabLog;
